import { v4 as uuidv4 } from 'uuid';
import { FileApi } from 'api';

const DEFAULT_PATH = `jm_coffee`;

/**
 * 파일 업로드
 * --
 * @param {string} path
 * @param {File} file
 * @returns
 */
const FileUpload = async (path = 'default', file) => {
  // const { uploadFile } = useFileUpload();
  if (!file) return console.error('파일이 없습니다!');

  const body = new FormData();

  // 파일 원본명
  const originName = file.name;
  // 버킷 경로 설정
  const buketName = `${DEFAULT_PATH}/${path}/${uuidv4()}`;

  body.append('file_name', buketName);
  body.append('file', file);

  try {
    const { data, status, message } = await FileApi.uploadFile(body, false);

    if (status !== 200)
      return {
        data,
        status,
        message,
      };

    return {
      status,
      message,
      data: {
        file_name: buketName,
        origin_name: originName,
      },
    };
  } catch (err) {
    console.log('[File Uplaod] Error!', err);
    throw err;
  }
};

/**
 * 파일 업로드
 * --
 * @param {string} path
 * @param {File[]} file
 * @returns
 */
const MultiFileUpload = async (path = 'default', files = []) => {
  // const { uploadFile } = useFileUpload();
  if (!files.length) return console.error('파일이 없습니다!');

  const body = new FormData();

  const fileNames = files.map(() => `${DEFAULT_PATH}${path}/${uuidv4()}`);
  body.append('file_names', JSON.stringify(fileNames));

  // 버킷 경로 설정 및 파일 추가
  files.forEach((file) => {
    // File 객체 직접 추가 (브라우저 환경)
    if (file instanceof File) {
      body.append('files', file);
    } else {
      console.error('올바른 파일 형식이 아닙니다:', file);
    }
  });

  try {
    const { data, status, message } = await FileApi.multiUploadFile(
      body,
      false
    );

    if (status !== 200)
      return {
        data,
        status,
        message,
      };

    return {
      status,
      message,
      data: data,
    };
  } catch (err) {
    console.log('[File Multi Uplaod] Error!', err);
    throw err;
  }
};

const FileDownload = async (path = '') => {
  if (!path) return console.error('파일 경로가 없습니다!');

  try {
    const { data, status, message } = FileApi.downloadFile({
      file_name: path,
    });

    return {
      data,
      status,
      message,
    };
  } catch (err) {
    console.log('[File Download] Error!', err);
    throw err;
  }
};

export const FileManager = {
  upload: FileUpload,
  multiUpload: MultiFileUpload,
  download: FileDownload,
};
